import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { listDocumentTypes } from "../actions/documentTypeActions";

export default function DocumentTypes() {
  const dispatch = useDispatch();

  const { documentTypes, loading, error } = useSelector(
    (s) => s.documentTypeList
  );

  useEffect(() => {
    if (documentTypes == undefined) {
      dispatch(listDocumentTypes());
    } else if (documentTypes.length == 0) {
      dispatch(listDocumentTypes());
    }
  }, [dispatch, documentTypes]);

  return (
    <>
      {loading ? (
        <option value="0" key="1">
          Loading...
        </option>
      ) : documentTypes ? (
        documentTypes.map((countf, index) => (
          <option key={index + 1} value={countf.Id}>
            {countf.DocumentName}
          </option>
        ))
      ) : (
        <option value="0" key="1">
          {error}
        </option>
      )}
    </>
  );
}
